import { render, staticRenderFns } from "./FilterDropdown.vue?vue&type=template&id=50e0c081&scoped=true&"
import script from "./FilterDropdown.vue?vue&type=script&lang=js&"
export * from "./FilterDropdown.vue?vue&type=script&lang=js&"
import style0 from "./FilterDropdown.vue?vue&type=style&index=0&id=50e0c081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e0c081",
  null
  
)

export default component.exports